const languagePairLocale = {
  emptyText: "未设置"
};
export {
  languagePairLocale
};
//# sourceMappingURL=zh_CN.js.map
